<template>
  <div class="change-stock-refurbish">
    <div>
      <h1 class="item-title" style="margin-bottom: 0;">{{ $t('components_change_stock_refurbish.sxfzbfxsb') }}</h1>
      <div class="search-hd" v-if="model.type!== 'watch'">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item>
            <el-button type="primary" icon="el-icon-plus" @click="onDeviceDialog()" >
              {{ $t('components_change_stock_refurbish.she_bei') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-bottom: 30px">
        <custom-table
          ref="customTb1"
          index
          :tableCode="model.type!== 'watch'?'crm_stock_refurbish':'crm_stock_refurbish_approval' "
          :data="bodyNumList"
          @filter="filterChange"
          @sort="sortChange"
          :filterArr="[]"
          :slots="['action']"
        >
          <!-- 操作 -->
          <template slot="action" slot-scope="scope" v-if="model.type!== 'watch'">
            <el-button type="text" size="mini" @click="onDel(scope.$index,scope.row)">{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>
      <el-form :model="form" ref="form" :rules="rules" label-width="auto">
        <el-form-item :label="$t('components_change_stock_refurbish.fan_zong_bu_yuan_yin')" prop="applyDesc">
          <el-input :disabled="model.type === 'watch'" type="textarea" :rows="4" v-model="form.applyDesc" style="width: 636px"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 选择设备 -->
    <refurbish-select v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onSelectDevice"></refurbish-select>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import refurbishSelect from './children/refurbish_select_dialog.vue';

export default {
  props: {
    model: {
      type: Object,
      default() {
        return {
          type: '', // add / edit / watch
          changeId: '' // 新增时为orderId, 编辑查看时为changeId
        };
      }
    }
  },
  components: {
    refurbishSelect
  },
  data() {
    return {
      orgList: [],
      detail: {},
      bodyNumList: [],
      dialogVisible: false,
      dialogModel: {},
      dialogVisible1: false,
      dialogModel1: {},
      form: {
        applyId: '',
        approvalState: '',
        applyDesc: '',
        bodyNumList: []
      },
    };
  },
  computed: {
    rules() {
      return {
        applyDesc: [{ required: true, message: this.$t('Common.com_required') }, { max: 200, message: this.$t('Common.com_rules_length_max', [200]), }]
      };
    },
    isSubmit: vm => !vm.bodyNumList.length
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    getList: function (list) {
      this.orgList = list;
    },

    // 初始化
    initDialog: function () {
      if (this.model.type === 'add') {
        // this.form.orderId = this.model.changeId;
        this.bodyNumList.push(this.model.row);
      }
      if (this.model.type === 'edit') {
        this.form.applyId = this.model.changeId;
        this.getChangeDetail();
      }
      if (this.model.type === 'watch') {
        this.form.applyId = this.model.changeId;
        this.getChangeDetail();
      }
    },

    // 获取变更详情
    getChangeDetail: function () {
      this.$getJSON(apis.renovateApplyInfo, {
        applyId: this.model.changeId
      }).then((res) => {
        this.$setFormatData(this.form, res.data);
        this.bodyNumList = res.data.applyDeviceList;
      });
    },

    // 选择设备弹窗
    onDeviceDialog: function () {
      this.dialogModel.title = this.$t('components_change_stock_refurbish.xzxfzbfxdsb');
      this.dialogModel.existBodyNumList = this.bodyNumList;
      this.dialogVisible = true;
    },
    // 选择设备保存
    onSelectDevice: function (deviceList) {
      // 合并
      this.bodyNumList = [...this.bodyNumList, ...deviceList];
    },
    // 删除
    onDel(index) {
      const tips = this.$t('components_change_stock_refurbish.nqdyscdqxzdfxsbm');
      this.$showConfirm(tips)
        .then(() => {
          this.bodyNumList.splice(index, 1);
        })
        .catch(() => {});
    },
    // 确认保存
    onConfirm: function (approve) {
      if (this.model.type === 'watch') {
        this.$emit('close');
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.bodyNumList.length) {
          this.$message.error(this.$t('components_change_stock_refurbish.qnxzxfxdsb'));
          return;
        }
        // 1-草稿，6-审批中
        this.form.approvalState = approve ? '6' : '1';

        this.form.bodyNumList = this.bodyNumList.map(i => i.bodyNum);
        this.$postJSON(apis.renovateApplySaveOrUpdate, this.form).then((res) => {
          const result = res.data || {};
          if (!result.id) {
            this.$alert(result.errorMsg, this.$t('components_change_stock_refurbish.qxscyxhtcg'), {
              confirmButtonText: this.$t('Common.com_close'),
              callback: () => {}
            });
            return;
          }
          if (approve) {
            this.$postJSON(`${apis.apsApproveApprovalApproveStart}/return_hq_renovate_apply/${result.id}`, this.form, true).then(() => {
              this.$message({
                message: this.$t('Common.com_handle_success'),
                type: 'success'
              });
              this.$emit('success');
            });
          } else {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success'
            });
            this.$emit('success');
          }
        });
      });
    }
  }
};
</script>

<style lang="scss">
.change-stock-refurbish{

}

</style>
